import { Card, CardContent, Skeleton, Stack } from "@mui/material";
import { useSearchParams } from "react-router";
import { FormSubmission, FormSubmissionProperties } from "src/components";
import { useGetFormSubmission, type GetOneOnOneMeetingDto } from "src/http";
import { UserFeedbackTabs } from "src/pages/UserPages/UserFeedbackPage/components";

interface Props {
  meeting: GetOneOnOneMeetingDto;
}

const UserFeedbackAgendaStep = (props: Props) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const formSubmissionGuid = searchParams.get("formSubmissionGuid");
  const { data: formSubmission, isLoading } = useGetFormSubmission(searchParams.get("formSubmissionGuid"));

  if (formSubmissionGuid == null) {
    return (
      <UserFeedbackTabs
        userId={props.meeting.otherUser.userId}
        onClicked={(e, formSubmissionGuid) => {
          e.preventDefault();
          setSearchParams((searchParams) => {
            searchParams.set("formSubmissionGuid", formSubmissionGuid);
            return searchParams;
          });
        }}
      />
    );
  }

  if (isLoading || formSubmission === undefined) {
    return (
      <Card>
        <CardContent>
          <Stack spacing={2}>
            {[...Array(2)].map((_, i) => (
              <Stack key={i} spacing={1}>
                <Skeleton variant="rectangular" height={30} />
                {[...Array(2)].map((_, j) => (
                  <Stack key={j} spacing={0.5}>
                    <Skeleton variant="rectangular" height={24} />
                    <Skeleton variant="rectangular" height={72} />
                  </Stack>
                ))}
              </Stack>
            ))}
          </Stack>
        </CardContent>
      </Card>
    );
  }

  return (
    <Stack spacing={1}>
      <Card>
        <CardContent>
          <FormSubmissionProperties
            formSubmission={formSubmission}
            propertyVisibility={{
              reviewedInOneOnOne: true,
            }}
            onBackClicked={() => {
              setSearchParams((searchParams) => {
                searchParams.delete("formSubmissionGuid");
                return searchParams;
              });
            }}
          />
        </CardContent>
      </Card>
      <Card>
        <CardContent>
          <FormSubmission formSubmission={formSubmission} />
        </CardContent>
      </Card>
    </Stack>
  );
};

export { UserFeedbackAgendaStep };
